<template lang="pug">
.form-label.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
    .form-section
      .input-container
        input.input(v-model="dataForm.label" autocomplete="ño" :disabled="fillData" required)
        label.label(:class="{ show: dataForm.label }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="label" title="Nombre de la Etiqueta")
      .input-container
        input.input(v-model="dataForm.width" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.width }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="width" title="Ancho")
      .input-container
        input.input(v-model="dataForm.height" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.height }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="height" title="altura")
      .input-container
        input.input(v-model.number="dataForm.quantity" type="number" min="1" max="10" autocomplete="ño" required)
        label.label(:class="{ show: Number.isInteger(dataForm.quantity) }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="quantity" title="Cantidad")
      .input-container
        input.input(v-model="dataForm.containerWidth" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.containerWidth }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="containerWidth" title="Ancho Del Contenedor")
      .input-container
        input.input(v-model="dataForm.padding" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.padding }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="padding" title="Padding Izquierdo y Derecho")
      .input-container
        input.input(v-model="dataForm.spaceBetween" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.spaceBetween }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="spaceBetween" title="Espacio Entre Etiquetas")

    .divider

    .center
      .print-layout.center(:style="dataForm.quantity > 1 ? `width:${dataForm.containerWidth}; padding:0 ${dataForm.padding}` : ''")
        .center.line(v-for="n in dataForm.quantity")
          .label-code(:style="buildStyleShape(dataForm.width, dataForm.height)")
            .shape-label(v-for="(shape, index) in dataForm.shapes" @click="select('shapes', index)" :style="buildStyleShape(shape.width, shape.height, shape.top, shape.left)" :class="{'selected-element': selected.array ? shape === dataForm[selected.array][selected.index] : false}")

            .code-label.left(v-for="(code, index) in dataForm.codes" @click="select('codes', index)" :style="buildStyleString(code.width, code.height, code.top, code.left, code.degrees)" :class="{'selected-element': selected.array ? code === dataForm[selected.array][selected.index] : false, dark: code.bold}")
              .font-128 {{ code128(code.testText) }}

            .code-label.left(v-for="(qrcode, index) in dataForm.qrcodes" @click="select('qrcodes', index)" :style="buildStyleString('', '', qrcode.top, qrcode.left, qrcode.degrees)" :class="{'selected-element': selected.array ? qrcode === dataForm[selected.array][selected.index] : false}")
              QRCode(:text="qrcode.text" :width="qrcode.width")

            .string-label.center.uppercase(v-for="(string, index) in dataForm.strings" @click="select('strings', index)" :style="buildStyleString(string.width, string.height, string.top, string.left, string.degrees)" :class="{'selected-element': selected.array ? string === dataForm[selected.array][selected.index] : false, dark: string.bold}") {{ string.testText }}

            img.image-label(v-for="(image, index) in dataForm.images" :src="`${imagePath}/${image.folder}/${image.name}`" :alt="image.name" @click="select('images', index)" :style="buildStyleShape(image.width, image.height, image.top, image.left, image.degrees)" :class="{'selected-element': selected.array ? image === dataForm[selected.array][selected.index] : false}")

    .divider

    .add-panel
      .add-shape(@click="addShape")
      .add-string(@click="addString") Aa
      .add-code(@click="addCode") Code
      .add-qrcode(@click="addQRCode") QRCode
      .add-image(@click="addImage") Image

    .divider

    .config-code(v-if="selected.array")
      .input-container
        input.input(v-model="dataForm[selected.array][selected.index]['height']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['height'] }") Height

      .input-container(v-if="dataForm[selected.array][selected.index]['heightText'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['heightText']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['heightText'] }") Height Text

      .input-container(v-if="dataForm[selected.array][selected.index]['width'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['width']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['width'] }") Width

      .input-container
        input.input(v-model="dataForm[selected.array][selected.index]['left']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['left'] }") Left

      .input-container
        input.input(v-model="dataForm[selected.array][selected.index]['top']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['top'] }") Top

      .input-container(v-if="dataForm[selected.array][selected.index]['text'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['text']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['text'] }") Text

      .input-container(v-if="dataForm[selected.array][selected.index]['testText'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['testText']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['testText'] }") Test Text

      .input-container(v-if="dataForm[selected.array][selected.index]['bold'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['bold']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['bold'] }") Bold

      .input-container(v-if="dataForm[selected.array][selected.index]['folder'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['folder']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['folder'] }") Folder

      .input-container(v-if="dataForm[selected.array][selected.index]['name'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['name']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['name'] }") Name

      .input-container(v-if="dataForm[selected.array][selected.index]['degrees'] !== undefined")
        input.input(v-model="dataForm[selected.array][selected.index]['degrees']" autocomplete="ño")
        label.label(:class="{ show: dataForm[selected.array][selected.index]['degrees'] }") Degrees

    .divider

    .list-shapes Shapes
      .list-shape(v-for="(shape, index) in dataForm.shapes" @click="deleteElement('shapes', index)") Shape {{ index }}
    .list-strings Strings
      .list-string(v-for="(string, index) in dataForm.strings" @click="deleteElement('strings', index)") {{ string.text }}
    .list-codes Codes
      .list-code(v-for="(code, index) in dataForm.codes" @click="deleteElement('codes', index)") {{ code.text }}
    .list-codes QRCodes
      .list-code(v-for="(qrcode, index) in dataForm.qrcodes" @click="deleteElement('qrcodes', index)") {{ qrcode.text }}
    .list-codes Images
      .list-code(v-for="(image, index) in dataForm.images" @click="deleteElement('images', index)") {{ image.folder }} / {{ image.name }}

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteLabel")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gqlLabel from '@/graphql/label'
import QRCode from '@/components/elements/QRCode'

export default {
  name: 'FormLabel',

  mixins: [mForm, mFilters, mDB],

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  components: { QRCode },

  data () {
    return {
      dataForm: {
        width: '35mm',
        height: '60mm',
        containerWidth: '103mm',
        padding: '1.5mm',
        spaceBetween: '2mm',
        quantity: 1,
        shapes: [],
        strings: [],
        codes: [],
        qrcodes: [],
        images: []
      },
      selected: {
        array: '',
        index: ''
      },
      resolver: 'label',
      key: 'label',
      gql: gqlLabel
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newLabel()
      } else {
        this.updateLabel()
      }
    },

    newLabel () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateLabel () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteLabel () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    select (array, index) {
      const arraySelected = this.selected.array
      const indexSelected = this.selected.index

      if (arraySelected === array && indexSelected === index) {
        this.selected.array = ''
        this.selected.index = ''
      } else {
        this.selected.array = array
        this.selected.index = index
      }
    },

    addShape () {
      this.dataForm.shapes.push({
        width: '50%',
        height: '5mm',
        left: '25%',
        top: '0mm'
      })
    },

    addString () {
      this.dataForm.strings.push({
        width: 'auto',
        height: '3.5mm',
        left: '0mm',
        top: '0mm',
        text: 'text',
        bold: true,
        testText: 'test',
        degrees: '0deg'
      })
    },

    addCode () {
      this.dataForm.codes.push({
        width: 'auto',
        height: '10mm',
        heightText: '3.5mm',
        left: '0mm',
        top: '0mm',
        text: 'text',
        testText: 'HK1',
        degrees: '0deg'
      })
    },

    addQRCode () {
      this.dataForm.qrcodes.push({
        width: '50',
        height: '10mm',
        heightText: '3.5mm',
        left: '0mm',
        top: '0mm',
        text: 'text',
        testText: 'HK1',
        degrees: '0deg'
      })
    },

    addImage () {
      this.dataForm.images.push({
        width: 'auto',
        height: '5mm',
        left: '0mm',
        top: '0mm',
        folder: 'others',
        name: 'logo-print.png',
        degrees: '0deg'
      })
    },

    deleteElement (array, index) {
      const arraySelected = this.selected.array
      const indexSelected = this.selected.index

      if (arraySelected === array && indexSelected === index) {
        this.selected.array = ''
        this.selected.index = ''
      }

      this.dataForm[array].splice(index, 1)
    },

    buildStyleShape (width, height, top, left, degrees) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `height:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    },

    buildStyleString (width, height, top, left, degrees) {
      const style = {
        width: width ? `width:${width};` : '',
        height: height ? `font-size:${height};` : '',
        top: top ? `top:${top};` : '',
        left: left ? `left:${left};` : '',
        degrees: degrees ? `transform: rotate(${degrees});` : ''
      }

      return `${style.width}${style.height}${style.top}${style.left}${style.degrees}`
    }
  },

  watch: {
    dataOriginal: {
      handler () {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-label
  position relative

.code
  position relative

.print-layout
  display inline-flex
  justify-content space-between
  background-color #0f0f0f

.add-panel
  display flex
  justify-content space-between
  align-items center

.label-code
  background-color white
  display inline-block
  position relative
  overflow hidden

.shape-label
  background-color black
  position absolute
  transform-origin top left

.string-label
  color black
  position absolute
  text-align center
  white-space nowrap
  transform-origin top left

.code-label
  color black
  position absolute
  white-space nowrap
  transform-origin top left

.image-label
  position absolute
  box-sizing initial
  transform-origin top left

.description-128
  padding 0 1em

.add-shape
  height 1.5em
  width 3em
  background-color black

.add-shape, .add-string, .add-code, .add-image
  cursor pointer

.selected-element
  background-color #FF5968
</style>



// WEBPACK FOOTER //
// src/components/pages/label/Form.vue